import { QuerySubmittedProposalDTO } from './../models/internal/query-submittedproposal-dto';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CreateProposalDTO } from '../models/createproposaldto';
import { SearchFilter } from '../models/internal/searchfilter';
import { HttpService } from './http.service';
import { PackageType } from '../models/packagetype';
import { TransportMode } from '../models/transportmode';
import { DunnageType } from '../models/dunnagetype';
import { PackageMaterial } from '../models/packagematerial';
import { Proposal } from '../models/proposal';
import { PackageLevelTemplate } from '../models/packageleveltemplate';
import { Constants } from '../core/constants';
import { UpdateProposalStatusDTO } from '../models/internal/updateproposalstatusdto';
import { PartInfo } from '../models/partinfo';
import { UpdateHotRequestDTO } from '../models/internal/updatehotrequestdto';
import { PartBasicInfo } from '../models/partbasicinfo';
import { CopyProposalDTO } from '../models/internal/copy-proposal-dto';
import { Observable, BehaviorSubject } from 'rxjs';
import { RejectionReason } from '../models/rejection-reason';
import { QueryPendingProposalDTO } from '../models/internal/query-pendingproposal-dto';
import { QueryRejectedProposalDTO } from '../models/internal/query-rejectedproposal-dto';
import { QueryPartNoProposalDTO } from '../models/internal/query-part-noproposal-dto';
import { UserDTO } from '../models/external/user-dto';
import { PEAssignment } from '../models/pe-assignment';
import { PartSystemDTO } from '../models/external/partsystem-dto';
import { QueryProposalDTO } from '../models/internal/query-proposal-dto';
import { QueryPartMasterDTO } from '../models/internal/query-partmaster-dto';
import { ResponsePartMasterDTO } from '../models/internal/response-partmaster-dto';
import { SearchFilterCondition } from '../models/internal/searchfiltercondition';
import { QueryApprovedPECreateDTO } from '../models/internal/query-approved-pe-create';
import { QueryByStatusDTO } from '../models/internal/query-bystatus-dto';
import { QueryExistingProposalForSupplierDTO } from '../models/internal/query-existingproposal-supplier-dto';
import { WhereInFilter } from '../models/internal/wherein-filter';
import { ProposalInternalComment } from '../models/proposal-internal-comment';
import { ProposalExternalComment } from '../models/proposal-external-comment';
import { QueryInternalCommentDTO } from '../models/internal/query-internal-comment-dto';
import { QueryExternalCommentDTO } from '../models/internal/query-external-comment-dto';
import { UpdateProposalCommentDTO } from '../models/internal/update-proposal-comment-dto';
import { QueryPartInfoSearchByPartNumberDTO } from '../models/internal/query-partInfo-searchby-partnumber-dto';
import { QueryPartProposalsSearchDTO } from '../models/internal/query-partproposals-search-dto';
import { QueryPackageTemplatesForSupplierDTO } from '../models/internal/query-packagetemplates-forsupplier-dto';
import { QueryPackageTemplatesForPEDTO } from '../models/internal/query-packagetemplates-for-pe-dto';
import { QueryAssignmentsForPEDTO } from '../models/internal/query-assignments-for-pe-dto';
import { QueryGetMaterialDTO } from '../models/internal/query-getmaterial-dto';
import { SessionstorageService } from './sessionstorage.service';
import { SourceType } from '../models/sourcetype';
import { QueryBaseForPEDTO } from '../models/internal/query-base-for-pe';
import { QueryPackageTemplatesForProposalDTO } from '../models/internal/query-packagetemplates-forproposal-dto';
import { PartMaster } from '../models/external/partMaster';
import { QueryExternalCommentUnReadDTO } from '../models/internal/query-external-comment-unread-dto';
import { QueryUpdateExternalCommentReadStatusDTO } from '../models/internal/query-external-comment-update-read-status-dto copy';
import { UpdateProposalPhysicalInspectionDTO } from '../models/internal/update-proposal-physical-inspection-dto';
import { ExemptedPartDTO } from '../models/internal/exemptedpart-dto';
import { ProposalImage } from '../models/proposal-image';
import { QueryExemptedPendingProposalDTO } from '../models/internal/query-exemptedpendingproposal-dto';
import { AddSourceTypeDTO } from './../models/addsourcetype-dto';
import { DueDateExtensionHistoryDTO } from 'src/app/models/duedateextensionhistory-dto';
import { QueryApprovedProposalDTO } from '../models/internal/query-approvedproposal-dto';
import { AdhocDueDateExtensionRequestHistoryDTO } from 'src/app/models/internal/adhocDueDateExtensionRequestHistory-dto';
import { UpdateAdhocDDExtensionStatusDTO } from '../models/internal/updateAdhocDDExtensionStatus-dto';
import { BasePage } from '../core/basepages/allbasepages';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from '../app.settings';
import { LocalstorageService } from './localstorage.service';
import { DeletePackageEngineerAssignmentDTO } from '../models/deletePackageEngineerAssignmentDTO';
import { PackageTemplateFile } from '../models/package-template-file';
import { FormFileToBeUploaded } from '../models/internal/formfile-tobe-uploaded';
import { AddPackageLevelTemplateSupplierDTO } from '../models/addpltsupplier-dto';
import { SioCode } from '../models/siocode';
import { PackageEngineerDTO } from '../models/internal/package-engineer-dto';
import { InfoButtonDTO } from '../models/internal/infobutton-dto';
import { InfoButtonImage } from '../models/infobutton-image';
import { ReassignPackageEngineerDTO } from '../models/reassign-packageengineerDTO';
import { ProposalEstimate } from '../models/proposal-estimate';
import { UpdateProposalEstimateRequestStatusDTO } from '../models/update-proposal-estimate-request-status-dto';
import { EstimateComment } from '../models/estimate-comment';
import { QueryEstimateCommentDTO } from '../models/internal/query-estimate-comment-dto';
import { QueryIncompleteProposalDTO } from '../models/internal/query-incompleteproposal-dto';

@Injectable({
    providedIn: 'root',
})
export class DataService extends BasePage {
    // TMS-15768 save due date extension to its history table
    // let headers
    public headers = new HttpHeaders().set('Content-Type', 'application/json');
    constructor(
        private http: HttpClient,
        private httpService: HttpService,
        private sessionstorageService: SessionstorageService,
        localstorageService: LocalstorageService,
        logger: NGXLogger,
        appSettings: AppSettings
    ) {
        super(localstorageService, logger, appSettings);
    }

    public uploadCriticalPartsExcel(doc: File): Observable<any> {
        const formData = new FormData();

        formData.append('file', doc);

        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };

        return this.httpService.post(
            '/partinfo/criticalparts/excel/upload',
            formData,
            undefined,
            'Uploading data'
        );
    }

    getCriticalPartsExcel(filter: any) {
        return this.httpService.post(
            '/partinfo/criticalparts/excel',
            filter,
            undefined,
            'Exporting data to file'
        );
    }

    getCriticalParts(filter: any) {
        return this.httpService.post('/partinfo/criticalparts', filter);
    }

    getCriticalClassList() {
        return this.httpService.get('/partinfo/criticalclass');
    }

    getPartInfo(ids: number[]) {
        // var ids: Number[] =  [688003, 8977];
        return this.httpService.get('/partinfo/range?ids=' + ids.toString());
    }
    getPackageTypes() {
        return this.httpService.getAll<PackageType>(
            '/packagetype/all',
            'Loading Package Types'
        );
    }
    getInfoButtons() {
        return this.httpService.getAll<InfoButtonDTO>(
            '/infobutton/all',
            'Loading Info Buttons'
        );
    }
    getInfoButton(id: number) {
        return this.httpService.getAll<InfoButtonDTO>(
            '/infobutton/' + id,
            'Loading Info Buttons'
        );
    }
    getReasonsNonSubTestDoc() {
        return this.httpService.getAll<PackageType>(
            '/reasonsnonsubtestdoc/all',
            'Loading Reasons master list for non-submission of ISTA docs'
        );
    }

    getTransportModes() {
        return this.httpService.getAll<TransportMode>(
            '/transportmode/all',
            'Loading Transport Modes'
        );
    }
    getSourceTypes() {
        return this.httpService.getAll<SourceType>(
            '/sourcetype/all',
            'Loading Business Locations'
        );
    }

    getParentSourceTypes() {
        return this.httpService.getAll<SourceType>(
            '/sourcetype/getParents',
            'Loading Business Locations'
        );
    }

    getSioCodes() {
        return this.httpService.getAll<SioCode>(
            '/siocode/all',
            'Loading SIO Codes'
        );
    }

    getDunnageTypes() {
        return this.httpService.getAll<DunnageType>(
            '/dunnagetype/all',
            'Loading Dunnage Types'
        );
    }
    getRejectionReasons() {
        return this.httpService.getAll<RejectionReason>(
            '/rejectionReason/all',
            'Loading Rejection Reason List'
        );
    }
    getServiceSourceTypes() {
        return this.httpService.getAll<string[]>(
            '/sourcetype/servicesourcetypes?silentquery',
            null
        );
    }
    getAllMaterials() {
        return this.httpService.getAll<RejectionReason>(
            '/packagematerial/all?orderby=description',
            'Loading Materials'
        );
    }
    getSupplier(supplierCode: string) {
        if (!supplierCode) {
            return null;
        }
        return this.httpService.get<PartMaster>(
            '/externaldata/supplier/all?silentquery=' + supplierCode,
            undefined,
            null
        );
    }

    getPECurrentAssignments(
        queryAssignmentsForPEDTO: QueryAssignmentsForPEDTO
    ) {
        return this.httpService.post(
            '/peassignment/pe/',
            queryAssignmentsForPEDTO,
            undefined,
            'Loading Current Assignments'
        );
    }

    getUnassignedPE(queryAssignmentsForPEDTO: QueryAssignmentsForPEDTO) {
        return this.httpService.post(
            '/peassignment/unassignedpe/',
            queryAssignmentsForPEDTO,
            undefined,
            'Loading Current Assignments'
        );
    }

    getExistingAssignments(queryAssignmentsForPEDTO: QueryAssignmentsForPEDTO) {
        return this.httpService.post(
            '/peassignment/existingassignments',
            queryAssignmentsForPEDTO,
            undefined,
            null
        );
    }

    getMaterials(queryGetMaterialDTO: QueryGetMaterialDTO) {
        // check in local storage for material list already fetched for package type & transport id combination
        const cacheKey =
            'materiallist_' +
            queryGetMaterialDTO.PackageTypeId +
            '_' +
            queryGetMaterialDTO.TransportModeId;
        return this.SyncWithCache(
            cacheKey,
            this.httpService.post(
                '/packagematerial/filtered',
                queryGetMaterialDTO,
                undefined,
                'Loading Materials'
            )
        );
    }

    getMaterialsByPackageType(packageTypeId: number) {
        // check in local storage for material list already fetched for package type & transport id combination
        return this.httpService.get(
            '/packagematerial/packageType/' + packageTypeId,
            undefined,
            'Loading Materials'
        );
    }

    SyncWithCache(cacheKey: string, fetchedList: Observable<ArrayBuffer>) {
        const cachedListSource = new BehaviorSubject<ArrayBuffer>(null);
        const cachedList = cachedListSource.asObservable();
        const value = this.sessionstorageService.retrieve(cacheKey);
        if (value) {
            cachedListSource.next(value);
            this.logDebug('using local cache for ', cacheKey);
            return cachedList;
        } else {
            this.logDebug('NO local cache found. Fetching.. ', cacheKey);
            fetchedList.subscribe((response: any) => {
                if (response && response.Data != null) {
                    this.sessionstorageService.store(cacheKey, response);
                }
            });
            return fetchedList;
        }
    }

    getPartSystems() {
        return this.httpService.getAll<PartSystemDTO>(
            '/peassignment/partsystem/all',
            'Loading Part Systems'
        );
    }

    getPartSystemsAvailableBySourceTypeId(sourceTypeId: number) {
        return this.httpService.getAll<PartSystemDTO>(
            '/peassignment/pe/availablepartsystem?sourceTypeId=' + sourceTypeId,
            'Loading Available Part Systems'
        );
    }

    getPartCategoriesForPE() {
        return this.httpService.post('/partcategory/pe', null);
    }

    getPEs() {
        return this.httpService.get(
            '/peassignment/pe/all',
            undefined,
            'Loading Package Engineer List'
        );
    }

    getProposalInternalComments(
        queryInternalCommentDTO: QueryInternalCommentDTO
    ) {
        return this.httpService.post(
            '/proposalinternalcomment/getforproposal',
            queryInternalCommentDTO,
            undefined,
            'Loading Internal Comments'
        );
    }

    getProposalEstimatecomments(
        queryEstimateCommentDTO: QueryEstimateCommentDTO
    ) {
        return this.httpService.post(
            '/proposalestimatecomment/getcomments',
            queryEstimateCommentDTO,
            undefined,
            'Loading Estimate Comments'
        );
    }
    getProposalExternalComments(
        queryExternalCommentDTO: QueryExternalCommentDTO
    ) {
        return this.httpService.post(
            '/proposalexternalcomment/getforproposal',
            queryExternalCommentDTO,
            undefined,
            'Loading Comments'
        );
    }
    getUnreadProposalExternalCommentCount(
        queryExternalCommentUnReadDTO: QueryExternalCommentUnReadDTO
    ) {
        return this.httpService.post(
            '/proposalexternalcomment/UnreadCountOfExternalComments',
            queryExternalCommentUnReadDTO,
            undefined,
            null
        );
    }
    getUnreadProposalExternalComments(
        queryExternalCommentUnReadDTO: QueryExternalCommentUnReadDTO
    ) {
        return this.httpService.post(
            '/proposalexternalcomment/getunreadExternalComments',
            queryExternalCommentUnReadDTO,
            undefined,
            null
        );
    }
    getProposalStatusHistory(proposalId: any) {
        return this.httpService.get(
            '/proposalstatushistory/' + proposalId,
            undefined,
            null
        );
    }
    updateUpdateReadStatusProposalExternalComment(
        queryUpdateExternalCommentReadStatusDTO: QueryUpdateExternalCommentReadStatusDTO
    ) {
        return this.httpService.post(
            '/proposalexternalcomment/UpdateReadStatus',
            queryUpdateExternalCommentReadStatusDTO,
            undefined,
            null
        );
    }
    getPendingProposals(queryPendingProposalDTO: QueryPendingProposalDTO) {
        return this.httpService.post(
            '/partinfo/pending/supplier',
            queryPendingProposalDTO,
            undefined,
            'Loading Pending Proposals'
        );
    }
    getPartsForSupplierForExemption(
        queryExemptedPendingProposalDTO: QueryExemptedPendingProposalDTO
    ) {
        return this.httpService.post(
            '/partinfo/supplier/exemption',
            queryExemptedPendingProposalDTO,
            undefined,
            'Loading Proposals for parts exemption'
        );
    }
    getPartsForSupplierForExemptionExcel(
        queryExemptedPendingProposalDTO: QueryExemptedPendingProposalDTO
    ) {
        return this.httpService.post(
            '/partinfo/supplier/exemption/excel',
            queryExemptedPendingProposalDTO,
            undefined,
            'Exporting data to file'
        );
    }
    updateExemptedPart(updateExemptPartDTOList: ExemptedPartDTO[]) {
        return this.httpService.post(
            '/exemptedpart/exemption',
            updateExemptPartDTOList,
            undefined,
            null
        );
    }
    getPendingProposalsExcel(queryPendingProposalDTO: QueryPendingProposalDTO) {
        return this.httpService.post(
            '/partinfo/pending/supplier/excel',
            queryPendingProposalDTO,
            undefined,
            'Exporting data to file'
        );
    }
    getAllPartsForSupplier(
        queryPartInfoSearchByPartNumberDTO: QueryPartInfoSearchByPartNumberDTO
    ) {
        return this.httpService.post(
            '/partinfo/all/supplier',
            queryPartInfoSearchByPartNumberDTO,
            undefined,
            'Loading Parts'
        );
    }
    getAllPartsForSupplierExcel(
        queryPartInfoSearchByPartNumberDTO: QueryPartInfoSearchByPartNumberDTO
    ) {
        return this.httpService.post(
            '/partinfo/all/supplier/excel',
            queryPartInfoSearchByPartNumberDTO,
            undefined,
            'Exporting data to file'
        );
    }
    getAllPartsForPE(QueryDTO: QueryPendingProposalDTO) {
        return this.httpService.post(
            '/partinfo/all/pe',
            QueryDTO,
            undefined,
            'Loading Parts'
        );
    }
    getAllPartsForPEExcel(QueryDTO: QueryPendingProposalDTO) {
        return this.httpService.post(
            '/partinfo/all/pe/excel',
            QueryDTO,
            undefined,
            'Exporting data to file'
        );
    }
    getProposalsForPart(
        queryPartProposalsSearchDTO: QueryPartProposalsSearchDTO
    ) {
        return this.httpService.post(
            '/partinfo/proposal/search',
            queryPartProposalsSearchDTO,
            undefined,
            'Loading Proposals'
        );
    }

    getPackageTemplateByIds(ids: number[]) {
        return this.httpService.post(
            '/packageleveltemplate/range',
            ids,
            undefined,
            'Loading Package Templates'
        );
    }

    getpartsForPE(queryPendingProposalDTO: QueryPendingProposalDTO) {
        return this.httpService.post(
            '/partinfo/pending/pe',
            queryPendingProposalDTO,
            undefined,
            'Loading Parts'
        );
    }

    getSourceTypesForPE() {
        return this.httpService.post('/sourcetype/pe', null);
    }

    getPartNoProposalForPE(queryPartNoProposalDTO: QueryPartNoProposalDTO) {
        return this.httpService.post(
            '/partinfo/noproposal/pe',
            queryPartNoProposalDTO
        );
    }

    getRejectedProposals(queryRejectedProposalDTO: QueryRejectedProposalDTO) {
        return this.httpService.post(
            '/partinfo/rejected/supplier',
            queryRejectedProposalDTO,
            undefined,
            'Loading Rejected Proposals'
        );
    }
    getRejectedProposalsExcel(
        queryRejectedProposalDTO: QueryRejectedProposalDTO
    ) {
        return this.httpService.post(
            '/partinfo/rejected/supplier/excel',
            queryRejectedProposalDTO,
            undefined,
            'Exporting data to file'
        );
    }
    getProposalsForSameBase7(partNumber: string) {
        return this.httpService.get(
            '/partinfo/proposals?base7partNumber=' + partNumber,
            { headers: this.headers }
        );
    }

    getExistingApprovedProposals_Supplier(queryProposalDTO: QueryProposalDTO) {
        return this.httpService.post(
            '/proposal/supplier/uom/approved',
            queryProposalDTO,
            { headers: this.headers },
            'Fetching Proposals to copy from'
        );
    }

    getExistingAllProposals_Supplier(
        queryDTOs: QueryExistingProposalForSupplierDTO[]
    ) {
        return this.httpService.post(
            '/proposal/existing/supplier',
            queryDTOs,
            { headers: this.headers },
            'Checking existing Proposals'
        );
    }

    getExistingApprovedProposals_PE(
        queryApprovedPECreateDTO: QueryApprovedPECreateDTO
    ) {
        return this.httpService.post(
            '/proposal/pe/approved',
            queryApprovedPECreateDTO,
            { headers: this.headers },
            'Fetching Proposals to copy from'
        );
    }
    getPackageLevelTemplatesByLevel(filter: WhereInFilter) {
        return this.httpService.post(
            '/packageleveltemplate/all/in',
            filter,
            { headers: this.headers },
            'Fetching Package Level Templates'
        );
    }
    getMasterParts(queryPartMasterDTO: QueryPartMasterDTO) {
        return this.httpService.post(
            '/externaldata/partmaster/query',
            queryPartMasterDTO,
            { headers: this.headers },
            'Fetching Parts'
        );
    }

    // getPartSystems() {
    //     return this.http.get(
    //         environment.WarpPartAPIUrl + '/partsystem?orderBy=partsystem',
    //         { headers: this.headers }
    //     );
    // }

    getProposalsForReview(queryByStatusDTO: QueryByStatusDTO) {
        return this.httpService.post(
            '/proposal/pe/status',
            queryByStatusDTO,
            undefined,
            'Loading Proposals'
        );
    }
    getProposalsForReviewExcel(queryByStatusDTO: QueryByStatusDTO) {
        return this.httpService.post(
            '/proposal/pe/status/excel',
            queryByStatusDTO,
            undefined,
            'Exporting data to file'
        );
    }

    getEstimateRequests(queryByStatusDTO: QueryByStatusDTO) {
        return this.httpService.post(
            '/ProposalEstimateRequest/queryTPM',
            queryByStatusDTO,
            undefined,
            'Loading Estimate Requests'
        );
    }
    getEstimateRequestsExcel(queryByStatusDTO: QueryByStatusDTO) {
        return this.httpService.post(
            '/ProposalEstimateRequest/querytpm/excel',
            queryByStatusDTO,
            undefined,
            'Loading Estimate Requests'
        );
    }
    getEstimateRequestsExcelForPE(queryByStatusDTO: QueryByStatusDTO) {
        return this.httpService.post(
            '/ProposalEstimateRequest/querype/excel',
            queryByStatusDTO,
            undefined,
            'Loading Estimate Requests'
        );
    }
    getProposalsWithPendingPhysicalInspection(
        queryByStatusDTO: QueryByStatusDTO
    ) {
        return this.httpService.post(
            '/proposal/pendinginspection',
            queryByStatusDTO,
            undefined,
            'Loading Proposals'
        );
    }
    getEstimate(id: string) {
        let spinnerMessage = 'Loading Proposal Estimate Data';
        return this.httpService.get<ProposalEstimate>(
            '/proposalestimate/' + id,
            spinnerMessage
        );
    }
    getProposalsByIds(ids: number[]) {
        return this.httpService.post(
            '/proposal/range',
            ids,
            undefined,
            'Loading Proposals'
        );
    }
    copyProposal(copyProposalDTO: CopyProposalDTO) {
        return this.httpService.post(
            '/proposal/copy',
            copyProposalDTO,
            undefined,
            'Copying proposal'
        );
    }
    addProposalInternalComment(
        proposalInternalComment: ProposalInternalComment
    ) {
        return this.httpService.post(
            '/proposalInternalComment',
            proposalInternalComment,
            undefined,
            'Adding Internal Comment'
        );
    }
    addProposalEstimateComment(estimateComment: EstimateComment) {
        return this.httpService.post(
            '/proposalEstimateComment',
            estimateComment,
            undefined,
            'Adding Estimate Comment'
        );
    }
    addProposalExternalComment(
        proposalExternalComment: ProposalExternalComment
    ) {
        return this.httpService.post(
            '/proposalExternalComment',
            proposalExternalComment,
            undefined,
            'Adding Comment'
        );
    }
    updateProposalComment(updateProposalCommentDTO: UpdateProposalCommentDTO) {
        return this.httpService.put(
            '/proposal/comment',
            updateProposalCommentDTO,
            undefined,
            'Updating Proposal Comment'
        );
    }

    updateProposalsStatus(updateProposalStatusDTO: UpdateProposalStatusDTO) {
        return this.httpService.put(
            '/proposal/status',
            updateProposalStatusDTO,
            { headers: this.headers },
            'Updating Proposal Status'
        );
    }
    updateProposalEstimateRequestStatus(
        updateStatusDTO: UpdateProposalEstimateRequestStatusDTO
    ) {
        return this.httpService.put(
            '/proposalestimaterequest/status',
            updateStatusDTO,
            { headers: this.headers },
            'Updating Proposal Estimate Request Status'
        );
    }
    UpdateProposalPhysicalInspectionStatus(
        updateProposalPhysicalInspectionDTO: UpdateProposalPhysicalInspectionDTO
    ) {
        return this.httpService.put(
            '/proposal/physicalinspection',
            updateProposalPhysicalInspectionDTO,
            { headers: this.headers },
            'Updating Proposal Physical Inspection Status'
        );
    }
    //TMS-29694 Send supplierCode to API so that we can filter PackageTemplates during PE login based on SupplierCode
    getPackageLevelTemplates(
        packageLevelId: number,
        packageMaterialId: number,
        transportModeId: number,
        packageTypeId: number,
        isSupplier: boolean,
        supplierCode: string,
        packageLevelTemplateIds: number[]
    ) {
        const searchFilter: SearchFilter = new SearchFilter();
        searchFilter.SearchFilterConditions = [
            // {
            //     Field: 'PackageLevelId',
            //     FilterValue: packageLevelId,
            // },
            {
                Field: 'PackageTypeId',
                FilterValue: packageTypeId,
                DataType: Constants.FILTER_DATATYPE_NUMBER,
                Operator: Constants.FILTER_OPERATOR_TYPE_EQUAL,
            },
            {
                Field: 'PackageMaterialId',
                FilterValue: packageMaterialId,
                DataType: Constants.FILTER_DATATYPE_NUMBER,
                Operator: Constants.FILTER_OPERATOR_TYPE_EQUAL,
            },
            {
                Field: 'TransportModeId',
                FilterValue: transportModeId,
                DataType: Constants.FILTER_DATATYPE_NUMBER,
                Operator: Constants.FILTER_OPERATOR_TYPE_EQUAL,
            },
        ];
        const queryPackageTemplatesForProposalDTO: QueryPackageTemplatesForProposalDTO =
            new QueryPackageTemplatesForProposalDTO();
        queryPackageTemplatesForProposalDTO.IsSupplier = isSupplier;
        queryPackageTemplatesForProposalDTO.SearchFilter = searchFilter;
        queryPackageTemplatesForProposalDTO.SupplierCode = supplierCode;
        queryPackageTemplatesForProposalDTO.PackageLevelTemplateIds = packageLevelTemplateIds;

        return this.httpService.post(
            '/packageLevelTemplate/proposal',
            queryPackageTemplatesForProposalDTO,
            undefined,
            'Loading Package Templates'
        );
        //     let cacheKey = "packagelevelTemplateList_" + packageMaterialId + "_" + transportModeId+ "_" + packageTypeId;
        //     return this.SyncWithCache(cacheKey, this.httpService.post(
        //         '/packageLevelTemplate/query',
        //        searchFilter, undefined, 'Loading Package Templates'
        //    ));
    }

    getPackageTemplatesListForSupplier(
        queryPackageTemplatesForSupplierDTO: QueryPackageTemplatesForSupplierDTO
    ) {
        return this.httpService.post(
            '/packageleveltemplate/supplier',
            queryPackageTemplatesForSupplierDTO,
            undefined,
            'Loading Package Templates'
        );
    }
    getPackageTemplatesListForPE(
        queryPackageTemplatesForPEDTO: QueryPackageTemplatesForPEDTO
    ) {
        return this.httpService.post(
            '/packageleveltemplate/pe',
            queryPackageTemplatesForPEDTO,
            undefined,
            'Loading Package Templates'
        );
    }
    getProposal(id: string, reload?: boolean) {
        let spinnerMessage = 'Loading Proposal Data';
        if (reload) {
            spinnerMessage = 'Reloading Proposal';
        }
        return this.httpService.get<Proposal>(
            '/proposal/' + id,
            spinnerMessage
        );
    }
    getProposalForReview(id: string, reload?: boolean) {
        let spinnerMessage = 'Loading Proposal Data for review';
        if (reload) {
            spinnerMessage = 'Reloading Proposal for review';
        }
        return this.httpService.get<Proposal>(
            '/proposal/review/' + id,
            spinnerMessage
        );
    }
    getPackageTemplateFileInfo(id: string, reload?: boolean) {
        let spinnerMessage = 'Loading Package Template file info';
        if (reload) {
            spinnerMessage = 'Reloading Package Template file for review';
        }
        return this.httpService.get<Proposal>(
            '/proposal/packageleveltemplatefile/' + id,
            spinnerMessage
        );
    }
    getPackageLevelTemplate(id: string) {
        return this.httpService.get(
            '/packageleveltemplate/' + id,
            'Loading Package Level Template'
        );
    }

    getSummaryForSupplier() {
        return this.httpService.get(
            '/partinfo/summary/supplier?silentquery=true',
            undefined,
            null
        );
    }
    getSummaryForPE() {
        return this.httpService.get(
            '/partinfo/summary/pe?silentquery=true',
            undefined,
            null
        );
    }

    getImageFile(id: string) {
        return this.httpService.get(
            '/ImageUpload/download/?proposalImageId=' + id
        );
    }

    getInfoButtonImageFile(infobuttonImage: InfoButtonImage) {
        return this.httpService.post(
            '/Infobutton/download',
            JSON.stringify(infobuttonImage),
            { headers: this.headers },
            'Getting Info Button Image'
        );
    }
    // getInfoButtonImageFile(infoButtonImage: InfoButtonImage) {
    //     return this.httpService.post(
    //         '/proposal',
    //         infoButtonImage,
    //        { headers: this.headers }, 'Getting Info Button Image');
    // }

    getDocumentFile(id: string) {
        return this.httpService.get(
            '/ProposalDocument/ProposalDocument/?proposalDocumentId=' + id
        );
    }
    getInfoDocumentFile(id: string) {
        return this.httpService.get(
            '/InfoButtonDocument/InfoButtonDocument/?InfoButtonDocumentId=' + id
        );
    }
    getAttachmentFile(id: string) {
        return this.httpService.get(
            '/PackageTemplateFile/download/?packageTemplateFileId=' + id
        );
    }

    makeHotRequest(updateHotRequestDTO: UpdateHotRequestDTO) {
        return this.httpService.put(
            '/partinfo/status',
            JSON.stringify(updateHotRequestDTO),
            { headers: this.headers }
        );
    }
    createPartInfo(partInfoList: PartBasicInfo[]) {
        return this.httpService.post(
            '/partinfo/multipleGetEntities',
            JSON.stringify(partInfoList),
            { headers: this.headers },
            'Syncing Part Information'
        );
    }

    postAdhocChargeback(dto: any) {
        return this.httpService.post(
            '/proposal/AdhocChargeback',
            JSON.stringify(dto),
            { headers: this.headers },
            'Issuing Chargeback'
        );
    }

    createProposal(proposal: CreateProposalDTO): any {
        return this.httpService.post(
            '/proposal',
            proposal,
            { headers: this.headers },
            'Adding Proposal'
        );
    }

    //tms-33944 change input parameter to array to allow multiple records
    addPEAssignment(peAssignmentDTO: PEAssignment[]): any {
        return this.httpService.post(
            '/peassignment',
            JSON.stringify(peAssignmentDTO),
            { headers: this.headers },
            'Adding PE Assignment'
        );
    }
    updateProposal(proposal: CreateProposalDTO) {
        return this.httpService.put(
            '/proposal',
            JSON.stringify(proposal),
            { headers: this.headers },
            'Updating Proposal'
        );
    }
    createPackageLevelTemplate(
        packageLevelTemplate: PackageLevelTemplate
    ): any {
        return this.httpService.post(
            '/packageLevelTemplate',
            JSON.stringify(packageLevelTemplate),
            { headers: this.headers },
            'Adding Package Template'
        );
    }

    updatePackageLevelTemplate(packageLevelTemplate: PackageLevelTemplate) {
        return this.httpService.put(
            '/packageLevelTemplate',
            JSON.stringify(packageLevelTemplate),
            { headers: this.headers },
            'Updating Package Template'
        );
    }

    checkForEffectivyGaps(proposal: CreateProposalDTO) :any {
        return this.httpService.post(
            '/proposal/CheckForEffectivyGaps',
            JSON.stringify(proposal),
            { headers: this.headers },
            'Verifying Dates for Proposal'
        );
    }
    

    getWarningPackageLevelTemplate(packageLevelTemplate: PackageLevelTemplate) : any {
        return this.httpService.post(
            '/packageLevelTemplate/Warning',
            JSON.stringify(packageLevelTemplate),
            { headers: this.headers },
            'Checking Associated Proposal Count');
    }

    deleteImage(proposalImageId: number) {
        return this.httpService.delete('/proposalimagedms/' + proposalImageId);
    }
    deleteInfoButtonImage(infoButtonImageId: number) {
        return this.httpService.delete('/infobuttonimage/' + infoButtonImageId);
    }
    deleteInfoButtonDocument(infoButtonDocumentId: number) {
        return this.httpService.delete(
            '/infobuttondocument/' + infoButtonDocumentId
        );
    }
    deleteDocument(proposalDocumentId: number) {
        return this.httpService.delete(
            '/proposaldocumentdms/' + proposalDocumentId
        );
    }

    deletePEAssignment(peAssignmentId: number) {
        return this.httpService.delete(
            '/peassignment/' + peAssignmentId,
            undefined,
            'Deleting assignment'
        );
    }

    deleteMultiplePEAssignment(
        deleteMultiplePEAssignment: DeletePackageEngineerAssignmentDTO
    ) {
        return this.httpService.put(
            '/peassignment/deletepeassignments',
            deleteMultiplePEAssignment,
            undefined,
            'Deleting multiple assignment'
        );
    }
    updatePEAssignment(reAssignmentDTO: PEAssignment[]) {
        return this.httpService.put(
            '/peassignment/',
            reAssignmentDTO,
            undefined,
            'Updating PE assignment'
        );
    }

    reassignFromDetailsScreen(reAssignmentDTO: PEAssignment) {
        return this.httpService.put(
            '/peassignment/reassignFromDetailsScreen',
            reAssignmentDTO,
            undefined,
            'Updating PE assignment from Details Screen'
        );
    }

    deleteProposal(proposalId: number) {
        return this.httpService.delete(
            '/proposal/' + proposalId,
            undefined,
            'Deleting Proposal'
        );
    }
    public uploadAdHocExcel(doc: File): Observable<any> {
        const formData = new FormData();

        formData.append('file', doc);

        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };

        return this.httpService.post(
            '/partinfo/UploadAdHocProposalRequest',
            formData,
            undefined,
            'Uploading data'
        );
    }
    public uploadBulkCreateProposalsExcel(doc: File): Observable<any> {
        const formData = new FormData();

        formData.append('file', doc);

        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };

        return this.httpService.post(
            '/proposal/UploadBulkCreateProposalsRequest',
            formData,
            undefined,
            'Uploading data'
        );
    }
    public uploadBulkEstimateRequestsExcel(doc: File): Observable<any> {
        const formData = new FormData();

        formData.append('file', doc);

        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };

        return this.httpService.post(
            '/proposalestimaterequest/UploadProposalEstimateRequest',
            formData,
            undefined,
            'Uploading data'
        );
    }
    public uploadBulkEstimateExcel(doc: File): Observable<any> {
        const formData = new FormData();

        formData.append('file', doc);

        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };

        return this.httpService.post(
            '/proposalestimate/UploadProposalEstimate',
            formData,
            undefined,
            'Uploading data'
        );
    }

    public uploadBulkCopyProposalsExcel(doc: File): Observable<any> {
        const formData = new FormData();

        formData.append('file', doc);

        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };

        return this.httpService.post(
            '/proposal/UploadBulkCopyProposalsRequest',
            formData,
            undefined,
            'Uploading data'
        );
    }
    public uploadSyncProposalsExcel(doc: File): Observable<any> {
        const formData = new FormData();

        formData.append('file', doc);

        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };

        return this.httpService.post(
            '/proposal/UploadSyncProposalsRequest',
            formData,
            undefined,
            'Uploading data'
        );
    }
    public uploadDocument(
        doc: File,
        proposalId: string,
        type: string
    ): Observable<any> {
        const formData = new FormData();

        formData.append('file', doc);
        // "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");
        formData.append('proposalId', proposalId);
        formData.append('type', type);

        // return this.http.post( '/ImageUpload/UploadFiles', formData);
        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };

        return this.httpService.post(
            '/documentupload/UploadFileFormData',
            formData
        );
    }

    public uploadInfoButtonDocument(
        doc: File,
        infoButtonId: string
    ): Observable<any> {
        const formData = new FormData();

        formData.append('file', doc);
        // "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");
        formData.append('infoButtonId', infoButtonId);

        // return this.http.post( '/ImageUpload/UploadFiles', formData);
        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };

        return this.httpService.post('/infobuttondocument/upload', formData);
    }

    public assignPackageTemplateToSuppliers(
        addPackageLevelTemplateSupplierDTO: AddPackageLevelTemplateSupplierDTO
    ): Observable<any> {
        return this.httpService.post(
            '/packageleveltemplatesupplier/AddPackageTemplateToSuppliers',
            JSON.stringify(addPackageLevelTemplateSupplierDTO),
            { headers: this.headers },
            'Adding Package Template Suppliers'
        );
    }

    /* AppSettings services */

    getAppSettingsByKey(paramkey: string) {
        return this.httpService.get(
            '/appsettings/' + paramkey,
            undefined,
            null
        );
    }

    //tms-30988 Commented out older method which calls api from appsettings using parameter. For security reason stop passing key as a parameter
    getNotificationMessage() {
        return this.httpService.get(
            '/partinfo/GetSupportMessage',
            undefined,
            null
        );
    }
    // TMS-15768 to get appsettings regarding due date extension
    getDueDateExtensionAppSettings() {
        return this.httpService.get(
            '/appsettings/duedateextension',
            undefined,
            null
        );
    }

    public uploadInspectionImage(proposalImage: ProposalImage) {
        return this.httpService.post(
            '/imageupload/UploadBase64Url',
            JSON.stringify(proposalImage),
            { headers: this.headers },
            'Adding Physical Inspection Image'
        );
    }

    public uploadInfoButtonImage(
        infoButtonImage: File,
        infoButtonId: string
    ): Observable<any> {
        const formData = new FormData();

        formData.append('file', infoButtonImage);
        formData.append('infoButtonId', infoButtonId);

        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };

        return this.httpService.post(
            '/infobutton/UploadFileFormData',
            formData
        );
    }

    public uploadImage(proposalImage: ProposalImage) {
        return this.httpService.post(
            '/imageupload/UploadBase64Url',
            JSON.stringify(proposalImage),
            { headers: this.headers },
            'Adding Proposal Image'
        );
    }

    public getMe(): Observable<any> {
        return this.httpService.get(`/peassignment/pe/self`);
    }

    // getExisitingProposals(queryPartProposalsSearchDTO: QueryPartProposalsSearchDTO) {
    //     return this.httpService.post(
    //         '/Proposal/proposal/findExistingProposals', queryPartProposalsSearchDTO , undefined, 'Check exisiting Proposols'
    //     );
    // }

    addSourceTypeforParentOrChildBusinessLocation(
        addSourceTypeDTO: AddSourceTypeDTO
    ) {
        return this.httpService.post(
            '/SourceType/AddParentOrChildBusinessLocation',
            JSON.stringify(addSourceTypeDTO),
            { headers: this.headers },
            'Adding Business Location'
        );
    }

    /* DueDateExtensionHistory services
        TMS-14954 Due date management logic implementation
    */

    // TMS-15768 save due date extension to its history table
    saveDueDateExtensionHistory(
        dueDateExtensionHistoryDTO: DueDateExtensionHistoryDTO
    ) {
        return this.httpService.post(
            '/duedateextensionhistory',
            JSON.stringify(dueDateExtensionHistoryDTO),
            { headers: this.headers },
            'Saving Due Date Extension'
        );
    }

    saveInfoButton(infobutton: InfoButtonDTO) {
        return this.httpService.put(
            '/infobutton/update',
            JSON.stringify(infobutton),
            { headers: this.headers },
            'Saving Info Button Information'
        );
    }
     //TMS-17428 GET all approved proposals
     getApprovedProposals(queryApprovedProposalDTO: QueryIncompleteProposalDTO) {
        return this.httpService.post(
            '/partinfo/approved/supplier',
            queryApprovedProposalDTO,
            undefined,
            'Loading Approved Proposals'
        );
    }

    //TMS-17628 Export approved proposals information in Excel sheet
    getApprovedProposalsExcel(
        queryApprovedProposalDTO: QueryIncompleteProposalDTO
    ) {
        return this.httpService.post(
            '/partinfo/approved/supplier/excel',
            queryApprovedProposalDTO,
            undefined,
            'Exporting data to file'
        );
    }

    getIncompleteProposals(queryApprovedProposalDTO: QueryApprovedProposalDTO) {
        return this.httpService.post(
            '/partinfo/incomplete/supplier',
            queryApprovedProposalDTO,
            undefined,
            'Loading Approved Proposals'
        );
    }

    //TMS-17628 Export approved proposals information in Excel sheet
    getIncompleteProposalsExcel(
        queryApprovedProposalDTO: QueryApprovedProposalDTO
    ) {
        return this.httpService.post(
            '/partinfo/incomplete/supplier/excel',
            queryApprovedProposalDTO,
            undefined,
            'Exporting data to file'
        );
    }

    // TMS-17427 Get Submitted proposals for suppliers
    getSubmittedProposals(
        querySubmittedProposalDTO: QuerySubmittedProposalDTO
    ) {
        return this.httpService.post(
            '/partinfo/submitted/supplier',
            querySubmittedProposalDTO,
            undefined,
            'Loading Submitted Proposals'
        );
    }

    // TMS-17427 Export Submitted proposals information to Excel sheet for suppliers
    getSubmittedProposalsExcel(
        querySubmittedProposalDTO: QuerySubmittedProposalDTO
    ) {
        return this.httpService.post(
            '/partinfo/submitted/supplier/excel',
            querySubmittedProposalDTO,
            undefined,
            'Exporting data to file'
        );
    }

    //TMS-20237 GET source type services for innerpack
    getInnerPackServiceSourceTypes() {
        return this.httpService.getAll<number[]>(
            '/sourcetype/InnerPackservicesourcetypes?silentquery',
            null
        );
    }

    //TMS-20775 GET AD hoc DDE Request List
    getAdhocDDERequestList() {
        return this.httpService.getAll<AdhocDueDateExtensionRequestHistoryDTO>(
            '/DueDateExtensionHistory/pe/GetRequestlistforAdhocDDE',
            'Loading Adhoc DDE Requests'
        );
    }

    //TMS-20775 Update request status for adhoc DDE
    updateAdhocDDERequestStatus(
        updateAdhocDDExtensionStatus: UpdateAdhocDDExtensionStatusDTO
    ) {
        return this.httpService.put(
            '/DueDateExtensionHistory/UpdateAdHocDDERequestStatus',
            updateAdhocDDExtensionStatus,
            undefined,
            'Updating Adhoc DDE Request Status'
        );
    }

    //tms-28072 get packageleveltemplatefile info from api
    getpackageLevelTemplateFiles(packageTemplateId: string) {
        return this.httpService.get(
            '/PackageTemplateFile/forpackagetmplate/?packageTemplateId=' +
                parseInt(packageTemplateId),
            undefined,
            'Loading Uploaded files'
        );
    }

    //tms-28072 upload single/multiple package template files
    public uploadPackageTemplateFile(
        packageTemplateFile: File[],
        packageTemplateId: string
    ): Observable<any> {
        let formData: FormData = new FormData();
        packageTemplateFile.forEach((file) => {
            formData.append('filesToUpload', file);
        });
        formData.append('packageTemplateId', packageTemplateId);
        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };
        return this.httpService.post(
            '/PackageTemplateFile/UploadFiles',
            formData
        );
    }

    //tms-28072 disable package template file
    deletePackageTemplateFile(packageTemplateId: number) {
        return this.httpService.delete(
            '/PackageTemplateFile/' + packageTemplateId,
            undefined,
            'Deleting existing uploads'
        );
    }

    //tms-28072 get packageleveltemplate supcode info from api
    getpackageLevelTemplateSupCode(packageTemplateId: string) {
        return this.httpService.get(
            '/PackageLevelTemplateSupplier/forpackagetmplatesupplierCode/?packageTemplateId=' +
                parseInt(packageTemplateId),
            undefined,
            'Loading Supplier Codes'
        );
    }

    deletePackageTemplateSupCode(packageTemplateId: number) {
        return this.httpService.delete(
            '/PackageLevelTemplateSupplier/' + packageTemplateId,
            undefined,
            'Deleting existing supcodes'
        );
    }

    checkProposalExistsforPLT(packageTemplateId: number, SupplierCode: number) {
        return this.httpService.get(
            '/PackageLevelTemplate/checkproposalExists/?packageTemplateId=' +
                packageTemplateId +
                '&supcode=' +
                SupplierCode.toString(),
            undefined,
            'Loading Supplier Codes'
        );
    }

    addPackageEngineerInfo(packageEngineerDTO: PackageEngineerDTO) {
        return this.httpService.post(
            '/PackageEngineer/AddOrUpdate/',
            packageEngineerDTO,
            undefined,
            'Adding Package Engineer'
        );
    }

    public uploadBulkPackageTemplateExcel(doc: File): Observable<any> {
        const formData = new FormData();

        formData.append('file', doc);

        const HttpUploadOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
        };

        return this.httpService.post(
            '/packageleveltemplate/UploadBulkCreatePackageTemplateRequest',
            formData,
            undefined,
            'Uploading package templates'
        );
    }

    //TMS-33963 get exempted parts from exempt table
    getallexemptedParts(
        queryExemptedPendingProposalDTO: QueryExemptedPendingProposalDTO
    ) {
        return this.httpService.post(
            '/partinfo/exemption/exemptedParts',
            queryExemptedPendingProposalDTO,
            undefined,
            'Loading exempted parts'
        );
    }

    getallexemptedPartsExcel(
        queryExemptedPendingProposalDTO: QueryExemptedPendingProposalDTO
    ) {
        return this.httpService.post(
            '/partinfo/exemption/exemptedParts/excel',
            queryExemptedPendingProposalDTO,
            undefined,
            'Exporting data to file'
        );
    }
}
